const BuyHome = () => import(/* webpackChunkName: "home" */ '@/modules/home/views/BuyHome')
const NotFound = () => import(/* webpackChunkName: "home" */ '@/modules/home/views/NotFound')

export default [
  {
    path: '/',
    name: 'Home',
    component: BuyHome
  },
  {
    path: '/notFound',
    name: 'NotFound',
    component: NotFound
  }
]
